import type { SetupConfig } from "./api";

const customShopifySetupFields = [
  "shopify_api_key",
  "shopify_api_secret",
  "shopify_webhook_secret",
  "shopify_store_domain",
  "shopify_embedded_app_url"
] as const;

export function isCustomDistributionMode(value: unknown): value is "custom" {
  return value === "custom";
}

export function setupConfigForDistributionSave(
  config: SetupConfig,
  distributionMode: unknown
): SetupConfig {
  const next = { ...config };
  delete next.shopify_distribution_mode;
  if (!isCustomDistributionMode(distributionMode)) {
    customShopifySetupFields.forEach((key) => delete next[key]);
  }
  return next;
}

export function customInstallShopDomain(
  distributionMode: unknown,
  configuredShopDomain: unknown
): string {
  if (!isCustomDistributionMode(distributionMode)) return "";
  return typeof configuredShopDomain === "string" ? configuredShopDomain.trim() : "";
}
